<template lang="pug">
v-card
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('ADD_TENANT.TITLE')}}
  v-card-text
    v-form(v-model="valid", ref="form")
      // name
      v-row.mt-4
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_TENANT.TENANTNAME')}}
        v-col.pa-0
          v-text-field.input-fontsize-small.mb-4(
            v-model='enterTenant',
            outlined,
            :placeholder=`$t('ADD_TENANT.TENANTNAME')`,
            dense
            :rules='formRule.nameRules',
            required='required',
            :hint=`$t('RULE.RULE_LOWER_ALPHA_NUMERIC')`
            persistent-hint
            :disabled='addBtn_loading'
          )
      // licensed
      v-row
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_TENANT.LICENSED')}}
        v-col.pa-0
          v-text-field.mb-4(
            v-model='addData.licensed',
            type='number',
            :min="1"
            outlined,
            dense
            :rules='formRule.integerRules',
            required='required',
            :hint=`$t('ADD_TENANT.LICENSED_HINT')`
            persistent-hint
            :disabled='addBtn_loading'
          )
      // 描述
      v-row.mb-4(style='margin-top: -10px')
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE.DESCRIPTION')}}
        v-col.pa-0
          v-textarea.pa-0.textarea-style(
            v-model="addData.description",
            outlined,
            height='100',
            no-resize
            :disabled='addBtn_loading'  
          ) 
    div.d-flex.align-center.justify-end(style='background-color: #f4f4f4; width: 480px; height:60px; margin-left:-24px; margin-bottom: -20px;')
      v-btn.mr-4(
        :ripple="false",
        @click="onCancel",
        width="100",
        height="40",
        color="cancel",
        depressed,
        outlined,
        style='font-weight: 700;'
        :disabled='addBtn_loading'
      ) {{$t('GENERAL.CANCEL')}}
      v-btn.mr-6(
        :ripple="false",
        @click="onConfirm",
        width="100",
        height="40",
        color="#14C6DE",
        depressed,
        dark,
      ) 
        v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
        .t-white(v-else style='font-weight: 700;') {{$t('TENANTCENTER.CREATE')}}

  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
    message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
    error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
  v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
    success-dialog(@emitSuccessDialog='onEmitSuccessDialog')

</template>

<script>
import Vue from "vue";
import messageDialog from '@/components/Dialog/redirectDialog';
import errorDialog from "@/components/Dialog/errorDialog";
import i18n from '/common/plugins/vue-i18n.js';
import TenantCenterService from "@/services/TenantCenterService";


export default Vue.extend({
  props: {
  },
  components: {            
      messageDialog,
      errorDialog
  },
  data() {
    return {
      addBtn_loading:false,
      addData : {},
      messageDialog:false,
      message:"",
      errorDialog: false,
      errorMessage: "",
      successDialog: false,
      valid: true,
      formRule: {
        nameRules: [
            (v) => !!v || i18n.t('RULE.RULE_R'),
            (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100'),
            (v) => /^[a-z0-9_]+$/.test(v) || i18n.t('RULE.RULE_LOWER_ALPHA_NUMERIC'), // 規則:小寫英文,數字,底線
        ],
        integerRules: [
          (v) => !!v || i18n.t('RULE.RULE_R') , // 必填
          (v) => /^[1-9]\d*$/.test(v) || i18n.t('RULE.RULE_ALPHA_NUMERIC'),
        ],
        descriptionRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100')
        ],
      },
      enterTenant:"",
      startCheck: false
    };
  },
  async created(){
    this.addData.name = '';
    this.addData.description = '';
    this.addData.licensed = 1;
    this.addData.domain = '';
    this.addData.is_primary = true;
  },
  methods: {
    validateForm() {
      if (this.$refs.form.validate()) 
        return true;
      else 
        return false;
    },
    async onConfirm() {
      if (this.validateForm() && !this.addBtn_loading) {
        this.addBtn_loading = true;
        this.addData.name = this.enterTenant;
        this.addData.schema_name = this.enterTenant;
        this.addData.domain = this.enterTenant;
        if(this.addData.description.trim() == ''){
          this.addData.description = this.enterTenant;
        }
        try {
          await TenantCenterService.createTenant(this.addData);
        } catch (error) {
          console.log(error);
          this.addBtn_loading = false;
          let error_msg = error.response.data.error;
          this.showErrorDialog(error_msg);
        } finally {
          this.$emit("emitAddTenatDialog", {close: true, tenant: this.enterTenant});
        }

      }
    },
    onCancel() {     
      this.$emit("emitNormalAddTenant", true);
    },
    showMessageDialog(msg) {                
        this.messageDialog = true;
        this.message = msg;
    },
    async onEmitMessageDialog() {
      this.messageDialog = false;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    async onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
      this.addBtn_loading = false;
    },
  },
});
</script>